import dynamic from "next/dynamic";

export const SectorHexagon = dynamic(() => import("./component"));
